import { gql } from '@apollo/client';

export const GET_CONTACT_ATTACHMENTS = gql`
  query ContactAttachments($contactId: Int!, $after: String, $first: Int) {
    contact(id: $contactId) {
      id
      attachments(after: $after, first: $first) {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          nextCursor
          previousCursor
          startCursor
        }
        nodes {
          id
          filename
          url
          mimeType
        }
      }
    }
  }
`;

export const GENERATE_ATTACHMENT_PRESIGNED_POST = gql`
  mutation GenerateAttachmentPresignedUrl(
    $input: GenerateContactAttachmentPresignedUrlInput!
  ) {
    generateAttachmentPresignedUrl(input: $input) {
      url
      fields {
        key
        value
      }
    }
  }
`;

export const UPLOAD_ATTACHMENT = gql`
  mutation UploadContactAttachment(
    $contactId: Int!
    $attachment: UploadContactAttachmentInput!
  ) {
    uploadContactAttachment(contactId: $contactId, attachment: $attachment) {
      id
      id
      filename
      url
    }
  }
`;

export const DELETE_ATTACHMENT = gql`
  mutation DeleteContactAttachment($id: ID!, $institutionId: Int!) {
    deleteContactAttachment(id: $id, institutionId: $institutionId) {
      attachment {
        id
      }
    }
  }
`;
